var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 34,
    viewBox: "0 0 23 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61232 17.0359L17.0342 1.61351C17.1857 1.46199 17.4314 1.46198 17.5829 1.6135L21.3852 5.4157C21.5368 5.56722 21.5368 5.81289 21.3853 5.96442L5.96338 21.3868C5.81186 21.5384 5.56619 21.5384 5.41466 21.3868L1.61233 17.5846C1.4608 17.4331 1.4608 17.1875 1.61232 17.0359Z",
    fill: "#5A9D5C",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65158 17.0044L5.37916 13.2766C5.55129 13.1045 5.83037 13.1045 6.0025 13.2766L21.3503 28.6239C21.5224 28.796 21.5224 29.0751 21.3503 29.2472L17.6227 32.9749C17.4506 33.1471 17.1715 33.1471 16.9994 32.9749L1.65159 17.6277C1.47946 17.4556 1.47946 17.1765 1.65158 17.0044Z",
    fill: "#FCEE21",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61131 17.0448L1.61177 17.0443L5.69108 12.965L10.0393 17.3131L5.69108 21.6613L1.61177 17.582C1.46249 17.4327 1.46315 17.1925 1.61131 17.0448Z",
    fill: "black",
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back_button.1a7dd03fa7558798a086daaed8512e2e.svg";
export { ForwardRef as ReactComponent };